import { ServerError } from "api/models/response/server-error";
import { AxiosError } from "axios";
import { number, ValidationError } from "yup";

export const convertServerErrorToValidationError = (dataErr: ServerError) => {
  const validationError: any = {
    message: dataErr.message,
    type: dataErr.code,
    errors: [],
    name: dataErr.code,
    inner: [],
    value: "",
    validationErrors: dataErr.validationErrors,
  };
  return validationError;
};

export const convertAxiosErrorToValidationError = (
  axiosEx: AxiosError
): ValidationError => {
  const dataErr = (axiosEx.response?.data as any)?.error as ServerError;
  return convertServerErrorToValidationError(dataErr);
};

export const numberNanable = () => {
  return number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable();
};
